var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-layout',{attrs:{"column":"","px-3":"","pb-3":""}},[_c('Heading',{attrs:{"title":_vm.$t('verify.TITLE')}}),_c('ErrorMessage'),_c('SuccessMessage')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }